module.exports = __webpack_public_path__ + "media/application/images/icons/dark-plus-7563ef14abfe5def919a43a903f0989a.svg";